export default {
  // 共通
  common: {
    back: '戻る',
    confirm: '確認',
    continue: '続ける',
    cancel: 'キャンセル',
    retry: '再試行',
    total: '合計',
    profile: 'マイページ',
    history: '履歴',
    pleaseLogin: 'ログインしてください',
    my: 'マイ',
    appName: 'AIスマート注文',
    loading: '読み込み中...',
    lang: '言語を選択',
    loadFailed: '読み込み失敗',
    operationFailed: '操作失敗',
    notSet: '未設定',
    country: '国',
    all: 'すべて',
    searchPlaceholder: '検索',
    noMore: 'これ以上ありません'
  },

  // ホーム
  home: {
    allFoods: 'すべての料理',
    headline: {
      sub: 'あなたの知らない',
      main: '{country}グルメ'
    },
    articleTag: 'ガイド',
    localGuideTitle: '現地攻略ガイド',
    recommendedArticlesAll: 'すべて',
    hotTopics: '人気のグルメテーマ',
    orderCallout: 'もう「これこれ」で注文しない!',
    mustEatBadge: '必食リスト',
    countrySelect: {
      eyebrow: '旅行先',
      title: '国を選択',
      subtitle: 'あなたに合った料理やガイドを提案します',
      footer: '左上でいつでも切り替え可能'
    },
    loadCountriesFailed: '国の読み込みに失敗しました'
  },

  // お気に入り
  favorites: {
    title: 'お気に入り',
    empty: 'お気に入りはまだありません',
    foods: '料理',
    articles: 'ガイド'
  },

  articleList: {
    title: '{country}ガイド',
    empty: 'おすすめガイドはまだありません'
  },

  // 料理詳細
  dishDetail: {
    quantity: '数量',
    introduction: '料理紹介',
    loadingIntroduction: '料理紹介を取得中...',
    getIntroduction: '料理紹介を取得',
    addToCart: 'カートに入れる（{count}点）',
    selectQuantity: '数量を選択',
    addedToCart: '{count}点をカートに追加しました',
    loadFailed: '紹介文の取得に失敗しました',
    noImage: '画像なし',
    imageSearchEmpty: '料理の一致する画像が見つかりません',
    imageSearchAction: '画像を検索',
    aiImageGenerating: 'AI画像生成中',
    generating: '生成中'
  },

  // タブバー
  tabbar: {
    home: 'ホーム',
    cameraOrder: '写真で注文',
    favorites: 'お気に入り',
    profile: 'マイ',
    camera: '撮影',
    menu: 'メニュー'
  },

  // カメラ
  camera: {
    translate: '翻訳先',
    takeOrUpload: 'タップして撮影またはアップロード',
    uploadHint: '複数枚対応、最大9枚',
    addMore: 'さらに追加',
    order: '注文を開始',
    selectLanguage: '翻訳言語を選択',
    singleMode: '1枚モード',
    multiMode: '複数モード',
    history: '履歴',
    takePhotoError: '撮影に失敗しました。再試行してください',
    cameraUnsupported: 'カメラ機能はサポートされていません',
    cameraPermissionDenied: 'カメラの権限がありません。設定で許可してください',
    capture: '続けて撮影',
    tapToCapture: 'タップして撮影',
    tapToStart: 'タップして撮影開始',
    readyToCapture: 'メニューを撮影',
    uploading: 'アップロード中...',
    uploadFailed: 'アップロード失敗',
    pleaseCapture: '先に写真を撮影してください',
    maxPhotosReached: '写真は最大9枚までです',
    photosAdded: '{count}枚追加しました',
    confirmUpload: 'アップロードを確認',
    uploadMessage: '{count}枚の写真をアップロードしてメニューを認識します',
    startRecognition: '認識を開始',
    confirmRecognition: '認識確認',
    willRecognize: '{count}枚のメニュー写真を認識します',
    continueShooting: '撮影を続ける',
    prepareUpload: 'アップロード準備中...',
    compressingImage: '画像を圧縮中...',
    compressionFailed: '圧縮失敗',
    useOriginal: '元画像を使う',
    takePhoto: 'タップして撮影',
    selectFromGallery: 'アルバムから選択',
    operationFailed: '操作に失敗しました。再試行してください',
    processingPhoto: '写真を処理中...',
    leavingPageWarning: '写真を処理中です。ページを離れますか？',
    restoreInfoMissing:
      '以前撮影した {count} 枚の写真情報を検出しましたが、画像データが失われています。再撮影してください',
    addedAndSkipped:
      ' {added} 枚を追加し、画像以外の {skipped} ファイルをスキップしました',
    remainingQuotaNotice: 'ユーザー{phone}様：サブスクリプション有効期間：{days}',
    guide: {
      step1: 'メニューを撮影',
      step2: 'AI認識＆翻訳',
      step3: 'メニュー生成'
    }
  },

  // ログイン
  login: {
    title: 'ログイン',
    phone: '携帯電話',
    code: '認証コード',
    phoneNumber: '携帯電話番号',
    verifyCode: '認証コード',
    sendCode: 'コード送信',
    resend: '再送信',
    login: 'ログイン',
    loggingIn: 'ログイン中...',
    success: 'ログイン成功',
    failed: 'ログイン失敗、後で再試行してください',
    loginSuccess: 'ログイン成功',
    loginFailed: 'ログイン失敗',
    phonePlaceholder: '携帯電話番号を入力',
    codePlaceholder: '認証コードを入力',
    phoneRequired: '携帯電話番号を入力してください',
    codeRequired: '認証コードを入力してください',
    phoneInvalid: '携帯電話番号の形式が正しくありません',
    codeInvalid: '認証コードは4〜6桁の数字です',
    phoneError: '携帯電話番号を確認してください',
    codeError: '認証コードが正しくありません',
    codeSent: '認証コードを送信しました',
    resendCode: '再送信',
    countdown: '{count}秒後に再試行',
    retryAfter: '{seconds}秒後に再試行',
    tooFrequent: '送信頻度が高すぎます。しばらくしてから再試行してください',
    dailyLimit: '本日の送信上限に達しました',
    sendFailed: '送信失敗。後で再試行してください',
    agreeTips: 'ログインすることで、利用規約とプライバシーポリシーに同意したことになります'
  },

  // メニュー
  menu: {
    title: 'メニュー',
    cartTitle: 'カート',
    checkout: '注文する',
    totalItems: '計{count}点',
    clearCart: 'カートを空にする',
    emptyCart: 'カートは空です',
    aiRecommend: 'AIおすすめ',
    addToCart: 'カートに入れる',
    viewDetail: '詳細',
    price: '価格',
    quantity: '数量',
    currentMenu: '現在のメニュー',
    clearCartConfirm: 'カートを空にしますか？',
    noMenuData: '先にメニューを撮影してください',
    confirmButton: 'OK',
    cancelButton: 'キャンセル',
    hint: 'ヒント',
    noMenuItemsFound: 'メニュー項目が認識されませんでした'
  },

  // AIおすすめ
  ai: {
    recommendedSets: 'おすすめセット',
    dishCount: '品',
    selectSetHint: 'おすすめセットを選択してください',
    noSelectedDishes: '先に料理を選択してください',
    setPrefix: 'セット',
    others: 'その他',
    diningOptions: '食事の好み',
    numberOfPeople: '人数',
    dietaryPreferences: '食事の好み',
    budgetRange: '予算範囲',
    getRecommendation: 'AIに選んでもらう',
    noSpicy: '辛くない',
    vegetarian: 'ベジタリアン',
    seafood: 'シーフード',
    meat: '肉料理',
    loading: 'おすすめを生成中...',
    recommendationTitle: 'AIがおすすめします',
    tastePreference: '味の好み',
    budgetPerPerson: '一人当たりの予算',
    allergyWarning: '食事制限（アレルゲン）',
    sweet: '甘い',
    sour: '酸っぱい',
    spicy: '辛い',
    bitter: '苦い',
    umami: '旨味',
    light: 'あっさり',
    heavy: 'こってり',
    dairy: '乳製品',
    eggs: '卵',
    fish: '魚',
    shellfish: '甲殻類',
    treeNuts: 'ナッツ類',
    peanuts: 'ピーナッツ',
    wheat: '小麦',
    soy: '大豆',
    selectOptions: '食事の好みを選択してください',
    peopleCountError: '人数は1人以上にしてください',
    budgetRangeError: '予算範囲は正の整数にしてください',
    budgetMaxMinError: '最高予算は最低予算以上である必要があります',
    submitFailed: '送信失敗。再試行してください',
    minBudget: '最低予算',
    maxBudget: '最高予算',
    to: '〜',
    yuan: '元',
    recommendProgress: 'AI推奨の進捗',
    analyzing: 'メニューを分析中...',
    generating: 'おすすめ案を作成中...',
    recommendReason: 'おすすめ理由',
    menuCombination: 'メニューの組み合わせ',
    dietaryNotes: '食事のアドバイス',
    servingSize: '推奨量',
    viewDetail: '詳細',
    goToCheckout: '注文へ',
    dish: '人前',
    menuOption: 'セット',
    recommendedDishes: 'おすすめ料理',
    categoryDishes: 'カテゴリ別',
    order: '注文',
    orderConversation: '注文会話'
  },

  // アップロード
  upload: {
    title: '認識中',
    uploading: 'アップロード中...',
    recognizing: 'メニュー認識中...',
    translating: '翻訳中...',
    generating: '結果生成中...',
    complete: '認識完了',
    failed: '認識失敗',
    progress: '進捗',
    detailsTitle: '認識詳細',
    retake: '戻って撮り直す',
    retryUpload: 'アップロードを再試行',
    buyBenefits: '特典をアップグレード',
    uploadingNow: 'アップロードしています',
    aiRecognizingImages: 'AIが画像を認識中',
    aiTranslatingMenu: 'AIがメニューを翻訳中',
    dynamicCompression: '画像を動的に圧縮中',
    ocrEngineIntegration: 'OCRエンジン連携中',
    agentEngineBoot: 'エージェントエンジン起動中',
    llmContextParsing: 'LLMコンテキスト解析中',
    ragTargetLanguage: 'RAGターゲット言語マッチング',
    cuisineRegionMapping: '料理・地域マッピング',
    enhancedTranslation: '拡張翻訳起動',
    dishMetadataClassification: '料理メタデータ分類',
    semanticUiConstruction: 'セマンティックUI構築',
    confirmCancelTitle: 'キャンセル確認',
    confirmCancelMessage: '認識をキャンセルしますか？',
    preparingCount: '{count}枚の写真を準備中...',
    startUploadCount: '{count}枚の写真をアップロード開始',
    processingComplete: '処理完了',
    navigatingSoon: 'まもなく移動します...',
    processingCompleteAndNavigate: '処理完了、移動します',
    createBackgroundTask: 'バックグラウンドタスクを作成中...',
    noPhotoFound: '写真データが見つかりません',
    pleaseRetake: '戻って再撮影してください',
    dataParseFailed: 'データ解析失敗',
    photoDataParseFailed: '写真データ解析失敗',
    photoDataFormatError: '写真データの形式エラー。再撮影してください',
    uploadFailedShort: 'アップロード失敗',
    failedShort: '失敗',
    errorTryAgain: '処理に失敗しました。再試行してください',
    menuNotFound: 'メニューが認識されませんでした。再撮影してください',
    otherLlmErr: 'メニュー翻訳失敗',
    finalizing: 'メニュー翻訳の最終処理中...',
    almostDone: 'まもなく完了します。しばらくお待ちください'
  },

  // エラー
  error: {
    network: 'ネットワークエラー。接続を確認してください',
    server: 'サーバーエラー。後で再試行してください',
    timeout: 'タイムアウトしました。再試行してください',
    unknown: '不明なエラー',
    auth: '認証失敗。再ログインしてください',
    selectImage: '画像ファイルを選択してください',
    imageTooLarge: '画像サイズは20MB以下にしてください',
    processPhotoFailed: '写真の処理に失敗しました。再試行してください',
    processFileFailed: 'ファイル処理失敗',
    pageStateError: 'ページの状態が異常です。再撮影してください',
    processingPhotos: '写真を処理中です。お待ちください...',
    livePhotoNotSupported: 'Live Photoは非対応です。通常の写真を選択してください',
    microphonePermissionDenied: 'マイクの権限が拒否されました。ブラウザの設定で許可してください',
    microphoneNotFound: 'マイクが見つかりません',
    microphoneInUse: 'マイクが他のアプリで使用されています',
    microphoneConfigNotSupported: 'マイクの設定がサポートされていません',
    recordingNotSupported: 'ブラウザが録音に対応していません',
    recordingError: '録音中にエラーが発生しました',
    forbidden: 'アクセス権限がありません',
    notFound: 'リソースが見つかりません',
    requestFailed: 'リクエスト失敗',
    configError: '設定エラー'
  },

  // 注文会話
  orderConversation: {
    title: '注文会話',
    menu_order: '注文',
    quantity: '数量',
    translatedText: '翻訳テキスト',
    orderText: '注文テキスト',
    userSpeak: '長押しして話す',
    waiterSpeak: '長押しして話す',
    customerSpeak: '長押しして話す',
    waiterSpec: '店員',
    customerSpec: 'お客様',
    dish_detail: '詳細',
    recording: '録音中...',
    common_confirm: '確認',
    customerRecording: 'お客様録音中...',
    recognizing: '認識中...',
    translating: '翻訳中...',
    recordingFailed: '録音失敗。マイク権限を確認してください',
    recognitionFailed: '音声認識失敗',
    translationFailed: '翻訳失敗',
    recognitionResult: '認識結果',
    blankAudio: '話す時間が短すぎます',
    noDishes: '料理が選択されていません',
    assistantIntro:
      'こんにちは。私はお客様の注文をサポートするアプリです。お客様は以下の料理を注文したいそうです。ご質問があれば、下のボタンを押し続けて話してください。翻訳してお伝えします。'
  },

  // プロフィール
  profile: {
    title: 'マイページ',
    memberCard: {
      title: '会員特典',
      dynamicTitle: 'あなたは現在{status}ユーザーです。<br />以下の特典をご利用いただけます：',
      feature1: ' メニュー高精度認識',
      feature2: ' 20以上の言語翻訳',
      feature3: ' AIおすすめ注文',
      feature4: ' 多国籍料理紹介',
      feature5: ' 連続音声会話翻訳',
      featureUsageTemplate: '{feature}（有効{count}）',
      unlock: '今すぐロック解除',
      unlockBenefits: '特典プランをアップグレード'
    },
    menu: {
      privacy: 'プライバシーポリシー',
      terms: '利用規約',
      feedback: 'フィードバック',
      serviceStatus: 'サービス状況',
      about: 'アプリについて'
    },
    redeem: {
      button: '特典引き換え',
      title: '特典引き換え',
      description: '引き換えコードを入力して特典を有効化してください。',
      placeholder: 'コードを入力',
      helper: '英字A-Zと数字0-9に対応。スペースは自動削除され、大文字小文字は区別しません。',
      submit: '引き換え',
      cancel: 'キャンセル',
      success: '引き換え成功。特典が更新されました',
      validation: {
        empty: 'コードを入力してください',
        length: 'コードは英字と数字を含む12文字です',
        format: 'コードの形式が正しくありません',
        checksum: 'コードの検証に失敗しました。確認して再試行してください'
      }
    },
    register: 'アカウントを解約',
    registerHint: '解約機能は開発中です',
    logout: 'ログアウト',
    logoutConfirm: {
      title: 'ログアウト',
      message: 'ログアウトしますか？'
    },
    logoutSuccess: 'ログアウトしました'
  },

  subscription: {
    subtitle: 'AI MENU PASS',
    title: 'AI注文特典を解放',
    columns: {
      feature: '比較一覧'
    },
    plans: {
      freeUser: '無料ユーザー',
      trial: '無料トライアル',
      trialTag: '期間限定',
      oneDay: '1日サブスクリプション',
      twoDay: '2日サブスクリプション',
      threeDay: '3日サブスクリプション',
      fiveDay: '5日サブスクリプション'
    },
    actions: {
      tryNow: '試用する',
      purchase: '購入する',
      continueTrial: '体験を続ける',
      trialUnavailable: '試用終了',
      renew: '更新する',
      subscribed: '購読中'
    },
    features: {
      validity: '残り有効期間',
      price: '価格',
      usageCount: '利用回数',
      aiTranslate: 'AIメニュー翻訳',
      aiTextDetail: '料理詳細\nテキスト版',
      aiRecommend: 'AIおすすめ注文',
      aiOrder: 'AI注文アシスト',
      aiVoice: '音声会話翻訳'
    },
    values: {
      days: '{count}日',
      lifetime: '無期限',
      free: '0',
      price: '{amount} 人民元',
      times: '{count}回',
      notAvailable: '-',
      comingSoon: '-（順次公開）'
    },
    remarkTitle: '特典説明',
    remarksText:
      '1. メニュー認識翻訳対応国：アジア：日本、韓国、タイ、ベトナム、シンガポール、マレーシア、インドネシア、UAE、トルコ；欧州：英国、フランス、ドイツ、オーストリア、スイス、イタリア、アイルランド、スペイン、ポルトガル、ロシア、チェコ、ハンガリー、クロアチア、オランダ、ルーマニア、スウェーデン；北米：米国、カナダ、メキシコ；南米：ブラジル、アルゼンチン、チリ、ウルグアイ、パラグアイ、コロンビア、ベネズエラ、パナマ、ペルー、エクアドル；その他：オーストラリア、ニュージーランド。' +
      '\n備考：スイスは独・仏・伊語、オーストリアは独語、南米（ブラジル除く）はスペイン語に対応。' +
      '\n2. 当社はページ表示内容およびルールの解釈権を有し、解釈は法令に従いユーザーの正当な権利を保護します。',
    toast: {
      trialRedirect: '完全版体験のアクティベーションへ移動します',
      purchaseRedirect: '特典購入へ移動します',
      contactAdmin: '管理者へ連絡して会員サービスを開通してください',
      noQuota: '利用回数が上限に達しました。「マイページ」で購入してください',
      subscriptionExpired: '会員特典の期限切れまたは回数上限です。「マイページ」で更新してください',
      trialExhausted: '試用回数が終了しました。「マイページ」で会員特典を購入してください',
      wechatRequired: '支払いはWeChat内ブラウザで行ってください',
      paySuccess: '支払い成功。特典が更新されました',
      payCancelled: '支払いがキャンセルされました',
      payFailed: '支払い失敗。後で再試行してください',
      payPending: '支払い結果を確認中です。後で注文状態を確認してください',
      productUnavailable: 'この商品は現在購入できません。後で再試行してください'
    },
    currentBenefits: '現在のプラン',
    moreDetails: '詳細',
    remainingBenefits: '残り',
    totalBenefits: '合計',
    expireTime: '有効期限',
    tabs: {
      compare: '比較',
      detail: '詳細'
    },
    upgradeTitle: 'プランをアップグレード',
    trialNoteTitle: '試用特典の説明',
    trialNoteText: 'トライアル会員はメニュー翻訳などの機能を体験できます。トライアル期間はサブスクリプション特典に影響しません。',
    statusDetail: {
      title: '特典詳細',
      planName: 'プラン名',
      startTime: '開始日',
      expireTime: '終了日',
      totalCount: '総回数',
      status: 'ステータス',
      statusMap: {
        pending: '有効化待ち',
        active: '有効',
        invalid: '無効/期限切れ'
      }
    },
    durations: {
      oneDay: '1日',
      twoDay: '2日',
      threeDay: '3日',
      fiveDay: '5日'
    },
    subscriptionSuffix: 'サブスクリプション',
    subscriptionName: '{duration}サブスクリプション',
    fiveDayDesc: '5日間有効',
    validityOnly: '{duration}の有効期限',
    validityAndUsage: '{duration}の有効期限、{usage}の利用回数込み',
    usageCountSimple: '利用回数'
  }
}
